import { createContext, useContext } from 'react';
import type {
    AddedToCartToastOptions,
    MinOrderFeedbackToastOptions,
    RecipeAddedToCartToastOptions,
    RemovedFromCartToastOptions,
    WishlistAddToCartToastOptions,
} from '@/components/toast/commerce-feedback-content';
import type { WishlistBulkAddSummary } from '@/lib/api/wishlist.server';

export type WishlistSavedFeedbackOptions = {
    productName: string;
    listNames: string[];
    removedListNames?: string[];
    alreadyInList?: boolean;
    bulkAddSummary?: WishlistBulkAddSummary;
};

export type GiftCardRemovedFeedbackOptions = {
    maskedLabel: string;
};

export type CommerceFeedbackContextValue = {
    showWishlistSaved: (options: WishlistSavedFeedbackOptions) => void;
    showGiftCardRemoved: (options: GiftCardRemovedFeedbackOptions) => void;
    showAddedToCart: (options: AddedToCartToastOptions) => void;
    showRemovedFromCart: (options: RemovedFromCartToastOptions) => void;
    showFailedToAddCart: () => void;
    showFailedToUpdateCart: () => void;
    showBasketQuotaExceeded: () => void;
    showMinOrderFeedback: (options: MinOrderFeedbackToastOptions) => void;
    showWishlistAddToCart: (options: WishlistAddToCartToastOptions) => void;
    showRecipeAddedToCart: (options: RecipeAddedToCartToastOptions) => void;
    showCartMessage: (message: string) => void;
    showGeneralAlert: (message: string) => void;
};

export const CommerceFeedbackContext = createContext<CommerceFeedbackContextValue | null>(null);

export function useCommerceFeedback(): CommerceFeedbackContextValue {
    const context = useContext(CommerceFeedbackContext);
    if (!context) {
        throw new Error('useCommerceFeedback must be used within CommerceFeedbackProvider');
    }
    return context;
}
